import type { Translator } from '@porotutu/i18n'
import type { FilterSelectSpec } from '@porotutu/react/components/FilterBar/FilterBar'
import { isFilteredBy } from '../../filters'
import type { WebhookSubscriptionListQuery } from '../queries'

export const ACTIVE_CHOICES = ['true', 'false'] as const

export const filtersFor = (
  t: Translator,
  query: WebhookSubscriptionListQuery,
): FilterSelectSpec[] => [
  {
    name: 'active',
    label: t('crm.webhook_subscriptions.filters.active'),
    value: String(query.active ?? ''),
    options: ACTIVE_CHOICES.map((choice) => ({
      value: choice,
      label: t(`crm.webhook_subscriptions.active.${choice}`),
    })),
  },
]

export const isFiltered = (query: WebhookSubscriptionListQuery) =>
  isFilteredBy(query, ['search', 'active'])
